<!--------------------------------------View 271-------------------------------------------------->
<span id="openModal7" data-bs-target="#view271C" data-bs-toggle="modal"></span>
<div class="modal fade hide modalbackgrod " id="view271C" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLongTitle" aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog1 modal-lg" role="document">
    <div class="modal-content">

      <div class="modal-header modal-header1 border-0">

        <h5 class="modal-title text-left font-header">271 Record</h5>

        <button type="button" class="btn-close" (click)="closeViewdetails()"></button>
      </div>
      <div class="modal-body modal-body1">
        <app-eligibility-details *ngIf="ISViewDetails" [Id]="EligibleId">
        </app-eligibility-details>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="closeViewdetails()">Cancel</button>
      </div>

    </div>
  </div>
</div>
<button type="button" class="btn blue-btn btn-sm butstyle mr-1 mb-4" data-bs-target="#printalert" data-bs-toggle="modal">
  <i class="fa fa-print"> </i>Print
</button>&nbsp;
<button type="button" class="btn blue-btn btn-sm butstyle mr-1 mb-4" data-bs-target="#differenceReportPrintAlert"
  data-bs-toggle="modal">
  <i class="fa fa-print"> </i>Print Difference Report
</button>&nbsp;
<button type="button" class="btn blue-btn btn-sm butstyle mr-1 mb-4" data-bs-toggle="modal"
data-bs-target="#exportascsvmodel"> Export as CSV</button>
<!-- </br> -->
<ejs-grid #grid id='grid' [dataSource]='data|async' [allowResizing]='true' *ngIf="global.globalAgencyId!=0"
  [allowSorting]='true' allowPaging='true' [allowFiltering]='true' [pageSettings]='initialPage'
  [filterSettings]='filterOptions' (actionBegin)="onActionComplete($event)" (dataStateChange)='dataStateChange($event)'
  [showColumnChooser]='true' (resizeStop)="onResize($event)" (queryCellInfo)='validatebutton($event)'>
  <!-- allowTextWrap='true'  [textWrapSettings]='wrapSettings' -->
  <e-columns>
    <e-column width=50 minWidth=50 uid="action" headerText="Action" textAlign='Center' [allowSorting]='false'
    [allowFiltering]='false'>
    <ng-template #template let-data>
      <button class="btn btn-edit-table" (click)="viewlasteb(data.clientPkId)"><i
          class="fa fa-eye"></i></button>&nbsp;

    </ng-template>
  </e-column>
    <e-column minWidth=150 field="clientName" headerText="Name" type='string'>
      <ng-template #filterTemplate let-data>
        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
      </ng-template>
    </e-column>
    <e-column minWidth=150 field="dob" headerText="DOB" type='date' [format]='formatOptions'>

    </e-column>

    <e-column minWidth=130 field="medicaid" headerText="Medicaid" type='string'>
      <ng-template #filterTemplate let-data>
        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
      </ng-template>
    </e-column>

    <e-column minWidth=130 field="isMAEligible" headerText="MA Eligible" type='boolean'>
      <ng-template #filterTemplate let-data>
        <ejs-dropdownlist id='dropdown' placeholder='Select MA Eligible' [dataSource]='eligiblitydropdata'
          [popupHeight]='height'>
        </ejs-dropdownlist>
      </ng-template>
      <ng-template #template let-data>
        <div class="btn-Check-table" style="pointer-events: none;" *ngIf="data.isMAEligible"><i
            class="fa fa-check-circle"></i></div>&nbsp;
        <div class="btn-remove-table" style="pointer-events: none;" *ngIf="data.isMAEligible == false"><i
            class="fa fa-times-circle-o"></i></div>&nbsp;
      </ng-template>
    </e-column>
    <e-column minWidth=130 field="planEnd" headerText="Plans End Date" type='datetime'
      [format]='formatOptions'>

    </e-column>
    <e-column minWidth=130 field="benefitEnd" headerText="Benefit End Date" type='datetime'
      [format]='formatOptions'>

    </e-column>
    <e-column minWidth=80 field="pmap" headerText="PMAP" type='string'>
      <ng-template #filterTemplate let-data>
        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
      </ng-template>
    </e-column>
    <e-column width=80 field="program" headerText="Program" type='string'>
      <ng-template #filterTemplate let-data>
        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
      </ng-template>
    </e-column>
    <e-column minWidth=120 field="waiver" headerText="Waiver" type='string'>
      <ng-template #filterTemplate let-data>
        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
      </ng-template>
    </e-column>
    <e-column minWidth=100 field="spendDown" headerText="SpendDown" type='boolean'>
      <ng-template #filterTemplate let-data>
        <ejs-dropdownlist id='dropdown' placeholder='Select SpendDown' [dataSource]='eligiblitydropdata'
          [popupHeight]='height'>
        </ejs-dropdownlist>
      </ng-template>
      <ng-template #template let-data>
        <div class="btn-Check-table" style="pointer-events: none;" *ngIf="data.spendDown"><i
            class="fa fa-check-circle"></i></div>
        <div class="btn-remove-table" style="pointer-events: none;" *ngIf="data.spendDown== false"><i
            class="fa fa-times-circle-o"></i></div>
      </ng-template>
    </e-column>
    <e-column minWidth=100 field="msho" headerText="MSHO" type='boolean'>
      <ng-template #filterTemplate let-data>
        <ejs-dropdownlist id='dropdown' placeholder='Select MSHO' [dataSource]='eligiblitydropdata'
          [popupHeight]='height'>
        </ejs-dropdownlist>
      </ng-template>
      <ng-template #template let-data>
        <div class="btn-Check-table" style="pointer-events: none;" *ngIf="data.msho"><i
            class="fa fa-check-circle"></i></div>
        <div class="btn-remove-table" style="pointer-events: none;" *ngIf="data.msho== false"><i
            class="fa fa-times-circle-o"></i></div>
      </ng-template>
    </e-column>




    <e-column minWidth=100 field="messages" headerText="Messages" type='string'>
      <ng-template #filterTemplate let-data>
        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
      </ng-template>
    </e-column>
    <e-column width="50" [showInColumnChooser]='false'>
      <ng-template #headerTemplate let-data>
          <div>
              <span id='show' (click)='showColumn()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                  </i></span>
          </div>
      </ng-template>
  </e-column>
    <!-- <e-column width=80 minWidth=80 uid="action" headerText="Actions" [showInColumnChooser]='false'>
    <ng-template #template let-data>
      <button class="btn btn-edit-table" (click)="Clientdatatobind(data);AddClient('edit');"
        *ngIf="fp.cilentupdate"><i class="fa fa-edit"></i></button>&nbsp;

    </ng-template>
  </e-column> -->

  </e-columns>
</ejs-grid>

<!--================================ print Model============================================-->
<span id="printalertOpen" data-bs-target="#printalert" data-bs-toggle="modal"></span>
<div class="modal fade" id="printalert" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog create-update-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Print confirmation</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeprint()" ></button>
      </div>
      <div class="modal-body">
        Do you want to print this record ?
      </div>
      <div class="modal-footer">

        <button class="btn btn-sm butstyle " (click)="print()">Print
        </button>
        <button type="button" class="btn blue-btn btn-sm" (click)="closeprint()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!--================================ print Difference Report Model============================================-->
<span id="differenceReportPrintAlertSpan" data-bs-toggle="modal" data-bs-target="#differenceReportPrintAlert"></span>
<div class="modal fade" id="differenceReportPrintAlert" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Print confirmation</h5>
        <button type="button" class="btn-close" (click)="closeDifferenceReportPrintAlert()"></button>
      </div>
      <div class="modal-body">
        Do you want to print Difference Report?
      </div>
      <div class="modal-footer">
        <button class="btn btn-sm butstyle " (click)="printDifferenceReport()">Print</button>
        <button class="btn btn-sm butstyle " (click)="closeDifferenceReportPrintAlert()">Cancel</button>
      </div>
    </div>
  </div>
</div>


<!-- exportascsvmodel -->

<span id="exportascsv" data-bs-toggle="modal" data-bs-target="#exportascsvmodel"></span>
<div class="modal fade" id="exportascsvmodel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Export as CSV</h5>

                <button type="button" class="btn-close" aria-label="Close" (click)="closecsvmodal()" >
                    
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-6">
                        <button class="btn btn-sm" (click)="exportEligibilitysWithPaginationCsv()">
                            Print Current page
                        </button>
                    </div>
                    <div class="col-lg-6">
                        <button class="btn btn-sm" (click)="exportEligibiltyCsv()">
                            Print All page
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" (click)="closecsvmodal()" >
                    Close
                </button>
            </div>
        </div>
    </div>
</div>